import type { Geometry } from 'ol/geom';

import { ajax } from 'cadenza/api-client/api';
import { MIMETYPE_JSON } from 'cadenza/api-client/api-constants';
import type { GlobalId } from 'cadenza/repository/global-id';

interface DialogDto {
  selectionFeaturesCount: number;
  themes: ThemeDto[];
  bufferUnits: BufferUnit[];
}

interface ThemeDto {
  id: string;
  name: string;
  maxFeaturesCount: number;
  existingFeaturesCount: number;
  maxPointsCount: number;
  existingPointsCount: number;
}

type BufferUnit = 'METERS' | 'KILOMETERS';

interface GeometryFilterDto {
  sourceLayerId: string;
  targetLayerId: string;
  conditionDefinitionSetId: GlobalId;
  conditionValuesSetHash: string;
  bufferWidth: number;
  bufferUnit: BufferUnit;
  srsCode: string;
  mapScale: number;
  geometries: NamedGeometryDto[];
}

interface NamedGeometryDto {
  printName: string;
  geometry: Geometry;
}

interface PointsValidationDto {
  selectionPointsCount: number;
}

/* @see net.disy.cadenza.gis.web.geometryfiltering.rest.GeometryFilteringEndpointController.java */
export function getDialogContent (mapId: string, layerId: string) {
  let url = `/geometryFiltering/dialog/${mapId}`;
  if (layerId) {
    url += `/${layerId}`;
  }
  return ajax<DialogDto>(url, {
    method: 'GET'
  });
}

/* @see net.disy.cadenza.gis.web.geometryfiltering.rest.GeometryFilteringEndpointController.java */
export function createGeometryFilter (filterDefinition: GeometryFilterDto) {
  return ajax<PointsValidationDto>('/geometryFiltering/filter', {
    method: 'POST',
    data: JSON.stringify(filterDefinition),
    contentType: MIMETYPE_JSON
  });
}

/* @see net.disy.cadenza.gis.web.geometryfiltering.rest.GeometryFilteringEndpointController.java */
export function getApplicableTargetLayers (mapId: string) {
  return ajax<DialogDto>(`/geometryFiltering/${mapId}/layers`);
}

/* @see net.disy.cadenza.gis.web.geometryfiltering.rest.GeometryFilteringEndpointController.java */
export function validatePoints (filterDefintion: GeometryFilterDto) {
  return ajax<void>('/geometryFiltering/validate', {
    method: 'POST',
    data: JSON.stringify(filterDefintion),
    contentType: MIMETYPE_JSON
  });
}
